const DiscoverMainPanel = () => import('client/Discover/DiscoverMainPanel.vue');

export default [
  {
    path: '/discover',
    name: 'discover',
    meta: {
      title: 'Discover',
      uiEvents_page: 'Discover Page',
    },
    components: {
      mainPanel: DiscoverMainPanel,
    },
  },
];
